import { DateRange, DataTable, ValueAccessor } from '../../../models';
import { applyDateRangeWindow } from '../applyDateRangeWindow';
import { DateWindowFunction, DateWindowTypes } from '../core';

export interface CustomDateWindow {
  range: DateRange;
  type: DateWindowTypes.CUSTOM;
}

export const customDateWindow = (range: DateRange, accessor: ValueAccessor<Date>): DateWindowFunction => {
  return (table: DataTable) => applyDateRangeWindow(table, range, accessor);
};

export const createCustomWindow = (range: DateRange): CustomDateWindow => {
  return {
    type: DateWindowTypes.CUSTOM,
    range,
  };
};
